var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ICONS_nieuwwwwww"),React.createElement("path",{"d":"M40.43,80.86A40.43,40.43,0,1,1,80.86,40.43,40.48,40.48,0,0,1,40.43,80.86ZM40.43,7A33.46,33.46,0,1,0,73.89,40.43,33.5,33.5,0,0,0,40.43,7Z","fill":"#2a2d58","key":1}),React.createElement("path",{"d":"M56.37,43.92H24.49a3.49,3.49,0,1,1,0-7H56.37a3.49,3.49,0,0,1,0,7Z","fill":"#f1b860","key":2})]);
}

Minus.defaultProps = {"viewBox":"0 0 80.86 80.86"};

module.exports = Minus;

Minus.default = Minus;
